import React from 'react'
import { store } from 'store'
import { Redirect } from 'react-router-dom'
import intersection from 'lodash/intersection';
import routePaths from './../../Router/routePaths'

export const withAuth = (Component, feature) => (props) => {
	if (isAllowed(feature)) {
		return <Component {...props} />
	} else {
		return null
	}
}

export const Auth = (props) => {
	if (props.feature && isAllowed(props.feature)) {
		return <>
			{props.children}
		</>
	} else return null
}

export const ProtectedRoute =
  (
    Route,
    feature,
    role,
    RedirectComp = Redirect,
    redirectTo = routePaths.homePage
  ) =>
  (props) => {
    if (isAllowed(feature) || (role && getRoles().includes(role))) {
      return <Route {...props} />;
    } else {
      return <RedirectComp to={redirectTo} />;
    }
  };

export const getRoles = () => {
	return store.getState().userInfo.roles;
}

export const getAllPossibleRoles = () => {
	return store.getState().userInfo.allPossibleRoles;
}

export const isAllowed = (feature) => {
	let userFeatures = store.getState().userInfo.features;
	if(userFeatures && feature && feature instanceof Array && feature.length > 0){
		//If the user has access to any of the feature in the array
		//We will return true
		return intersection(feature, userFeatures).length > 0;
	}
	return userFeatures && userFeatures.indexOf(feature) != -1;
}
